import ACTIONS, { FETCH_STATUS } from "../constants";
  
// SORT BUDGETS

export const sortBudgetRequest = (state) => ({
  type: ACTIONS.SORT_BUDGETS_CALL,
  payload: state,
});

export const sortBudgetRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_BUDGETS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_BUDGETS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_BUDGETS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// GET BUDGETS

export const getBudgetsRequest = (state) => ({
  type: ACTIONS.BUDGETS_CALL,
  payload: state,
});

export const getBudgetsAttempt = {
  pending: {
    type: ACTIONS.BUDGETS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.BUDGETS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.BUDGETS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};


// CREATE BUDGET

export const createBudgetRequest = (state) => ({
  type: ACTIONS.CREATE_BUDGET_CALL,
  payload: state,
});

export const createBudgetAttempt = {
  pending: {
    type: ACTIONS.CREATE_BUDGET.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_BUDGET.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_BUDGET.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE BUDGET

export const updateBudgetRequest = (state) => ({
  type: ACTIONS.UPDATE_BUDGET_CALL,
  payload: state,
});

export const updateBudgetAttempt = {
  pending: {
    type: ACTIONS.UPDATE_BUDGET.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_BUDGET.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_BUDGET.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// DELETE BUDGET

export const deleteBudgetRequest = (state) => ({
  type: ACTIONS.DELETE_BUDGET_CALL,
  payload: state,
});

export const deleteBudgetAttempt = {
  pending: {
    type: ACTIONS.DELETE_BUDGET.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_BUDGET.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_BUDGET.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// FLAG BUDGET

export const updateBudgetFlag = (state) => ({
  type: ACTIONS.BUDGET_FLAG_CALL,
  payload: state,
});

export const updateBudgetFlagAttempt = {
  pending: {
    type: ACTIONS.BUDGET_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.BUDGET_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.BUDGET_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};